import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/MailGroupsActions";
import * as api from "../../api/MailGroupsApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getMailGroups(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getMailGroups(action.payload);
        yield put(actions.setMailGroups(data || undefined));
    } catch (error) {
        yield put(actions.setMailGroups(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addMailGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addMailGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateMailGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateMailGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteMailGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteMailGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addMailAddresses(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addMailAddressesNew(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateMailAddresses(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateMailAddresses(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteMailAddress(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteMailAddress(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_MAILGROUPS, getMailGroups);
    yield takeEvery(actions.Types.ADD_MAILGROUP, addMailGroup);
    yield takeEvery(actions.Types.UPDATE_MAILGROUP, updateMailGroup);
    yield takeEvery(actions.Types.DELETE_MAILGROUP, deleteMailGroup);
    yield takeEvery(actions.Types.ADD_MAILADDRESSES, addMailAddresses);
    yield takeEvery(actions.Types.UPDATE_MAILADDRESSES, updateMailAddresses);
    yield takeEvery(actions.Types.DELETE_MAILADDRESS, deleteMailAddress);
}

const MailGroupsSaga = [fork(watchAll)];

export default MailGroupsSaga;
